<template>

    <div class="container">
        <h3 class="padding">Unfortunately we didn't receive the correct information</h3>
        <h3>please contact Jupix support</h3>

        <div class="padding">
            <p>Please close this window</p>
        </div>

    </div>

</template>

<script>

    export default {
        name: "IncompleteEntry",
        components: {},
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    };
</script>